// Module
var code = "<qr-code-generator ng-model=\"data[component.key][index].name\" options=\"component.settings.options\"></qr-code-generator> ";
// Exports
export default code;